export default __webpack_public_path__ + "static/media/pokemon_flying.3939f256.png";